<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex ma-0 md6 pa-1 xs12>
        <v-select
          :items="distributors"
          clearable
          item-text="name"
          item-value="id"
          label="Distribuidor"
          no-data-text="Datos no disponibles"
          v-model="filter.distId"
          v-on:change="onChangeDistributor"
        ></v-select>
      </v-flex>
      <v-flex ma-0 md6 pa-1 xs12>
        <v-select
          :items="laboratories"
          clearable
          item-text="name"
          item-value="id"
          label="Laboratorio"
          no-data-text="Datos no disponibles"
          v-model="filter.labId"
        ></v-select>
      </v-flex>

      <v-flex ma-0 md4 pa-1 xs12>
        <v-dialog
          :return-value.sync="filter.startDate"
          full-width
          ref="dialog1"
          v-model="modal.startDate"
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              append-icon="event"
              label="Desde"
              readonly
              v-model="filter.startDate"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker locale="es-es" scrollable v-model="filter.startDate">
            <v-spacer></v-spacer>
            <v-btn @click="modal.startDate = false" color="primary" flat text
              >Cancel</v-btn
            >
            <v-btn
              @click="$refs.dialog1.save(filter.startDate)"
              color="primary"
              flat
              text
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex ma-0 md4 pa-1 xs12>
        <v-dialog
          :return-value.sync="filter.endDate"
          full-width
          ref="dialog2"
          v-model="modal.endDate"
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              append-icon="event"
              label="Hasta"
              readonly
              v-model="filter.endDate"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker locale="es-es" scrollable v-model="filter.endDate">
            <v-spacer></v-spacer>
            <v-btn @click="modal.endDate = false" color="primary" flat text
              >Cancel</v-btn
            >
            <v-btn
              @click="$refs.dialog2.save(filter.endDate)"
              color="primary"
              flat
              text
              >OK</v-btn
            >
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex ma-0 md4 pa-1 xs12>
        <v-text-field
          placeholder="Buscar"
          v-model="filter.term"
          clearable
        ></v-text-field>
      </v-flex>
      <v-flex md12 text-xs-right xs12>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('searching', filter)" icon color="info">
          <v-icon>search</v-icon></v-btn
        >
        <v-btn @click="$emit('download')" icon color="success">
          <v-icon>cloud_download</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      modal: {
        startDate: false,
        endDate: false,
      },
      distributors: [],
      laboratories: [],
      filter: {
        distId: '',
        labId: '',
        startDate: '',
        endDate: '',
        term: '',
      },
    }
  },
  watch: {
    'filter.distId': function(val) {
      if (typeof val == 'undefined') {
        this.filter.distId = ''
        this.filter.labId = ''
      }
    },
    'filter.labId': function(val) {
      if (typeof val == 'undefined') {
        this.filter.labId = ''
      }
    },
  },
  methods: {
    onChangeDistributor(id) {
      this.laboratories = []
      if (id) {
        this.$store
          .dispatch('distributors/getById', { id: id })
          .then(response => {
            const data = response.laboratories
            for (let index = 0; index < data.length; index += 1) {
              this.laboratories.push({
                name: data[index].name,
                id: data[index].id,
              })
            }
          })
      }
    },
  },
  created() {
    this.$store.dispatch('distributors/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.distributors.push({
          name: data[index].name,
          id: data[index].id,
        })
      }
    })
  },
}
</script>
